import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn.js';
import { Card } from './card.js';
const VARIANT_CLASSES = {
    plain: 'p-6 text-sm text-[var(--color-state-danger-fg)]',
    bordered: 'border-[var(--color-state-danger-fg)] p-4 text-sm text-[var(--color-state-danger-fg)]',
};
/**
 * Inline error message, styled as a `Card`. Extracted from ~13 byte-identical
 * call sites across admin-module-* list/history pages (FP-18/FP-28 dedup,
 * Ruling R10). Per-site text stays with the caller as `children`.
 */
export const ErrorCard = React.forwardRef(({ variant = 'plain', className, ...props }, ref) => (_jsx(Card, { ref: ref, className: cn(VARIANT_CLASSES[variant], className), ...props })));
ErrorCard.displayName = 'ErrorCard';
//# sourceMappingURL=error-card.js.map